import { ReactNode } from "react";

import Filters from "components/Filters";
import FiltersSplit from "components/Filters/Split";
import FiltersSidebar from "components/Filters/Sidebar";
import FiltersContentWrapper from "components/Filters/ContentWrapper";
import {
  INITIAL_SORT_OPTION,
  INITIAL_SORT_DIRECTION,
  FILTER_TYPE,
} from "shared/SpaceliftVcsRepo/useSearchSpaceliftVcsReposSuggestions/constants";
import useSearchSpaceliftVcsReposSuggestions from "shared/SpaceliftVcsRepo/useSearchSpaceliftVcsReposSuggestions";

import { FILTERS_ORDER_SETTINGS_KEY } from "../constants";

type SpaceliftVcsReposFiltersLayoutProps = {
  children: ReactNode;
};

const SpaceliftVcsReposFiltersLayout = ({ children }: SpaceliftVcsReposFiltersLayoutProps) => {
  const { filters, filterOptionsMap, loading } = useSearchSpaceliftVcsReposSuggestions();

  return (
    <Filters
      filters={filters}
      filtersItemsOptionsMap={filterOptionsMap}
      filtersLoading={loading}
      sortOptions={[]}
      initialSortOption={INITIAL_SORT_OPTION}
      initialSortDirection={INITIAL_SORT_DIRECTION}
      filtersType={FILTER_TYPE}
      filtersOrderSettingsKey={FILTERS_ORDER_SETTINGS_KEY}
      disableViews
    >
      <FiltersSplit>
        <FiltersSidebar />
        <FiltersContentWrapper>{children}</FiltersContentWrapper>
      </FiltersSplit>
    </Filters>
  );
};

export default SpaceliftVcsReposFiltersLayout;
